import { getErrorMessage } from './getErrorMessage';

// The create endpoint may return only a message, without availability flags.
export const isSlotUnavailableResponse = (response) => {
  const payload = response?.response?.data ?? response;
  const result = typeof payload?.success === 'boolean' ? payload : payload?.data ?? payload;
  if (result?.success === true) return false;
  return Boolean(
    result?.slot_not_available ||
    result?.data?.available === false ||
    /\bslot is no longer available\b/i.test(getErrorMessage(payload))
  );
};
